export const BOOKMARK_LIST_ATOM = 'bookmark/atom';
export const BOOKMARK_LIST_SELECTOR = 'bookmark/selector';
